export default [
  {
    path: "/others/icons",
    name: "otherIcons",
    meta: { title: "Icons Remix", requiresAuth: true },
    component: () => import("../views/main/remix.vue"),
  },

  // ============================
  // ⚙️ Manage Monitor Routes
  // ============================
  {
    path: "/manage-monitor/users",
    name: "manageMonitorUsers",
    meta: { title: "Manage Users", requiresAuth: true },
    component: () => import("../views/main/admin/manage-monitor/users.vue"),
  },
  {
    path: "/manage-monitor/users/deleted",
    name: "manageMonitorUsersDeleted",
    meta: { title: "Deleted Users", requiresAuth: true },
    component: () =>
      import("../views/main/admin/manage-monitor/users-deleted.vue"),
  },
  {
    path: "/manage-monitor/vacancies",
    name: "manageMonitorVacancies",
    meta: { title: "Monitor Vacancies", requiresAuth: true },
    component: () => import("../views/main/admin/manage-monitor/vacancies.vue"),
  },

  {
    path: "/manage-monitor/applications/:code",
    name: "manageMonitorApplications",
    meta: { title: "Monitor Applications", requiresAuth: true },
    component: () =>
      import("../views/main/admin/manage-monitor/applicants/index.vue"),
  },

  // ============================
  // ⚙️ Settings Routes
  // ============================
  {
    path: "/settings/system-logs",
    name: "settingsSystemLogs",
    meta: { title: "System Logs", requiresAuth: true },
    component: () => import("../views/main/admin/settings/system-logs.vue"),
  },
  {
    path: "/settings/announcements",
    name: "settingsAnnouncements",
    meta: { title: "Announcements", requiresAuth: true },
    component: () => import("../views/main/admin/settings/announcements.vue"),
  },
  {
    path: "/settings/email-smtps",
    name: "settingsEmailSmtps",
    meta: { title: "Email SMTPs", requiresAuth: true },
    component: () => import("../views/main/admin/settings/email-smtps.vue"),
  },
  {
    path: "/settings/categories",
    name: "settingsCategories",
    meta: { title: "Job Categories", requiresAuth: true },
    component: () => import("../views/main/admin/settings/categories.vue"),
  },
  {
    path: "/settings/subcategories",
    name: "settingsSubCategories",
    meta: { title: "Job Sub Categories", requiresAuth: true },
    component: () => import("../views/main/admin/settings/sub-categories.vue"),
  },
  // {
  //   path: "/settings/attributes",
  //   name: "settingsAttributes",
  //   meta: { title: "Job Attributes", requiresAuth: true },
  //   component: () => import("../views/main/admin/settings/attributes.vue"),
  // },
  {
    path: "/settings/sub-attributes",
    name: "settingsSubAttributes",
    meta: { title: "Job Sub Attributes", requiresAuth: true },
    component: () => import("../views/main/admin/settings/sub-attributes.vue"),
  },

   {
    path: "/settings/user-manual",
    name: "settingsUserManual",
    meta: { title: "User Manual", requiresAuth: true },
    component: () => import("../views/main/admin/settings/user-manual.vue"),
  },

  {
    path: "/settings/contact-messages",
    name: "contactMessages",
    meta: { title: "Contact Messages", requiresAuth: true },
    component: () => import("../views/main/admin/settings/contact-messages.vue"),
  },

  // ============================
  // ⚙️ Reports Routes
  // ============================
  {
    path: "/reports/references/:ref_code",
    name: "reportsReferenceDetails",
    meta: { title: "Manpower Report Details" },
    component: () => import("../views/main/admin/reports/ref-details.vue"),
  },

  {
    path: "/reports/references",
    name: "reportsReferences",
    meta: { title: "Manpower Reports", requiresAuth: true },
    component: () => import("../views/main/admin/reports/references.vue"),
  },
  {
    path: "/reports/analytics",
    name: "reportsAnalytics",
    meta: { title: "Analytics", requiresAuth: true },
    component: () => import("../views/main/admin/reports/analytics.vue"),
  },
  {
    path: "/reports/exports",
    name: "reportsExports",
    meta: { title: "Exports", requiresAuth: true },
    component: () => import("../views/main/admin/reports/exports.vue"),
  },
  {
    path: "/reports/job-hired",
    name: "jobHired",
    meta: { title: "Job Hired", requiresAuth: true },
    component: () => import("../views/main/admin/reports/job-hired.vue"),
  },
];
